var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      class: _vm.btnClass,
      attrs: { id: _vm.id, title: _vm.title, "x-small": "", icon: "" },
      on: {
        click: function($event) {
          return _vm.action(_vm.actionParams)
        }
      }
    },
    [_c("v-icon", { class: _vm.icon })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }